export const LOAD_API_KEYS = 'LOAD_API_KEYS';
export const DELETE_API_KEY = 'DELETE_API_KEY';
export const ADD_API_KEY = 'ADD_API_KEY';
export const CLEAR_CREATED_API_KEY = 'CLEAR_CREATED_API_KEY';
